const getFinishSignupStatus = me => me.account.finish_signup_status
const getEmail = me => me.account.email_identity.email
const getEmailIdentityId = me => me.account.email_identity.id

export { getFinishSignupStatus, getEmail, getEmailIdentityId }
